import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '60vh',
      py: { xs: 4, md: 6 }
    }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: { xs: 4, md: 6 }, 
          textAlign: 'center',
          borderRadius: 3,
          maxWidth: '600px',
          width: '100%',
          mx: { xs: 2, md: 0 }
        }}
      >
        <ErrorOutlineIcon sx={{ 
          fontSize: { xs: 80, md: 120 }, 
          color: 'error.main', 
          mb: 3 
        }} />
        
        <Typography variant="h3" component="h1" gutterBottom sx={{ 
          fontSize: { xs: '2rem', md: '3rem' },
          fontWeight: 'bold',
          mb: 2
        }}>
          404
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom sx={{
          fontSize: { xs: '1.25rem', md: '1.5rem' },
          mb: 2
        }}>
          Sayfa Bulunamadı
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph sx={{ 
          mb: 4, 
          fontSize: { xs: '0.9rem', md: '1rem' },
          lineHeight: 1.6
        }}>
          Üzgünüz, aradığınız sayfa mevcut değil veya kaldırılmış olabilir.
          Ana sayfaya dönerek güncel içeriklere göz atabilirsiniz.
        </Typography>
        
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          justifyContent: 'center',
          flexDirection: { xs: 'column', sm: 'row' }
        }}>
          <Button 
            variant="contained" 
            color="primary" 
            size="large"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
            sx={{ 
              py: 1.5,
              px: 3,
              borderRadius: 2
            }}
          >
            Ana Sayfaya Dön
          </Button>
          <Button 
            variant="outlined" 
            color="primary" 
            size="large"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{ 
              py: 1.5,
              px: 3,
              borderRadius: 2
            }}
          >
            Geri Git
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default NotFoundPage; 